export enum FlexAlignContentOption {
    FlexStart = 'flex-start',
    Center = 'center',
    FlexEnd = 'flex-end',
    Stretch = 'stretch',
    SpaceBetween = 'space-between',
    SpaceAround = 'space-around'
}
